import { createElement, memo, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { hotelTheme } from '@max/leez-theme-hotel';
import { setCustomTheme } from '@max/leez-context';
import { TechStackUtil } from '@nibfe/mkt-common-utils';
import { setRemConfig } from '@max/leez-style-util';
import Sensor from '@max/mbc-sensor';
import ExploreProgress from './components/explore-progress';
import RewardRecords from './components/reward-records';
import CityFilterModal from './components/city-filter-modal';
import { useCityExploreData, PopupKey } from './hooks/useCityExploreData';
import { ActivityStatus, ClickFreeCardUseBtnTriggerFlowType } from './types/shared';
import { BID_MAP, BID_TYPE, ASSIST_MODAL_VAP, FREE_CARD_USED_VAP, FREE_CARD_UNUSED_VAP, CITY_SELECTOR_CITY_VAP } from './const';
import './index.scss';
import GuestAssistModal from './components/guest-assist-modal';
import LandmarkDetailModal from './components/landmark-detail-modal';
import CouponModal from './components/coupon-modal';
import FreeCardModal from './components/free-card-modal';
import UnJoinedActivityBanner from './components/unjoined-activity-banner';
import FreeOrderMainCard from './components/free-order-main-card';
import { useShare } from "./hooks/useShare/useShare.web";
import { preloadVap } from "./utils/vap-preload/index.web";
setCustomTheme(hotelTheme);
setRemConfig({
    enabled: true
});
preloadVap(ASSIST_MODAL_VAP);
preloadVap(FREE_CARD_USED_VAP);
preloadVap(FREE_CARD_UNUSED_VAP);
preloadVap(CITY_SELECTOR_CITY_VAP);
function CityExplore(props) {
    const ctx = useMonitorEngineContext();
    // ctx._runtimeInfo.queryParams.leaderId = '1'
    const { userId } = ctx._runtimeInfo.commonParams || {};
    const { leaderId } = ctx._runtimeInfo?.queryParams || {};
    const { activityStatus, viewModel, rawQueryInfoResponse, rawQueryRewardsResponse, freeOrder, popupMap, selectedLandmark, selectedRewardTabType, handleSelectCity, handleCloseAssistModal, handleClickLandmarkItem, handleCloseLandmarkDetailModal, handleCloseCouponModal, handleSelectRewardTabType, handleCloseRewardRecords, handleCloseFreeCardModal, handleCloseCityModal, handleJoinActivity } = useCityExploreData({
        feConfig: props,
        activityId: props.activityId,
        taskId: props.taskId
    });
    function lxReport(bid, bidType, extraVal) {
        try {
            const lxCommonParams = {
                activity_id: props.activityId,
                activity_status: activityStatus,
                task_id: props.taskId,
                city_id: viewModel.currentCityId,
                city_name: viewModel.currentCityName,
                user_id: userId,
                is_guest_mode: !!leaderId,
                leader_id: leaderId,
                inviter_id: leaderId
            };
            const valLab = extraVal ? {
                ...lxCommonParams,
                ...extraVal
            } : lxCommonParams;
            switch (bidType) {
                case BID_TYPE.MV:
                    ctx._LXReport.mvReport(bid, {
                        valLab
                    });
                    break;
                case BID_TYPE.MC:
                    ctx._LXReport.mcReport(bid, {
                        valLab
                    });
                    break;
                case BID_TYPE.MC_WITH_TAG:
                    ctx._LXReport.mcReportWithTag(bid, {
                        valLab,
                        tagKey: bid,
                        tagContent: valLab
                    });
                    break;
                default:
                    break;
            }
        }
        catch (e) {
            ctx._raptorReport.reportLog('上报埋点异常', e, {
                category: 'jsError',
                level: 'warn',
                tags: {
                    bid
                }
            });
        }
    }
    const { shareWXCard } = useShare();
    function handleInviteClick() {
        lxReport(BID_MAP.INVITE_BUTTON_MC, BID_TYPE.MC);
        shareWXCard({
            params: {
                taskId: props.taskId,
                leaderId: userId
            },
            shareConfig: props.shareConfig,
            onSuccess: () => { }
        });
    }
    useEffect(() => {
        if ([ActivityStatus.UNJOINED, ActivityStatus.ON_PROGRESS, ActivityStatus.HAVE_FREE_CARD].indexOf(activityStatus) > -1) {
            lxReport(BID_MAP.CITY_EXPLORE_MAIN_CARD_MV, BID_TYPE.MV);
        }
    }, [activityStatus]);
    if (TechStackUtil.isInEditor()) {
        return <View style={{
            width: '750rpx',
            height: '504rpx',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
        <Image source={{
            uri: 'https://img.meituan.net/makerjiulv/69f5b253ce3755ff773bf520c4c87a9963842.jpg'
        }} resizeMode="contain" style={{
            width: '702rpx',
            height: '504rpx'
        }}/>
      </View>;
    }
    return <Sensor className="city-explore-root" once onAppear={() => {
        lxReport(BID_MAP.COMPONENT_MV, BID_TYPE.MV);
    }}>
      <View x-if={activityStatus === ActivityStatus.LOADING} className="city-explore-loading">
        <Image className="city-explore-loading" source={{
        uri: 'https://img.meituan.net/makerjiulv/41c03ed70ad7e8c2ce5e2b8bbd06cbc615547.png'
    }}/>
      </View>
      <UnJoinedActivityBanner x-if={activityStatus === ActivityStatus.UNJOINED} onClickJoinButton={handleJoinActivity} feConfig={props}/>
      <ExploreProgress x-if={activityStatus === ActivityStatus.ON_PROGRESS} activityId={props.activityId} feConfig={props} currentCityName={viewModel.currentCityName} currentScore={viewModel.currentScore} totalScore={viewModel.totalScore} landmarks={viewModel.landmarks} onChangeTab={(tab) => {
        lxReport(BID_MAP.REWARD_BUTTON_MC, BID_TYPE.MC, {
            tab_id: tab
        });
        handleSelectRewardTabType(tab);
    }} onInviteButtonShow={() => {
        lxReport(BID_MAP.INVITE_BUTTON_MV, BID_TYPE.MV);
    }} onInviteClick={handleInviteClick} onOpenLandmark={(landmarkVo) => {
        lxReport(BID_MAP.LANDMARK_CLICK_MC, BID_TYPE.MC, {
            landmark_id: landmarkVo?.cardId
        });
        handleClickLandmarkItem(landmarkVo);
    }}/>
      <FreeOrderMainCard x-if={activityStatus === ActivityStatus.HAVE_FREE_CARD} currentCityName={viewModel.currentCityName} feConfig={props} cityExploreViewModel={viewModel} activityId={props.activityId} rewardItem={freeOrder} onUseClick={() => {
        lxReport(BID_MAP.FREE_CARD_USE_MC, BID_TYPE.MC, {
            id: freeOrder?.rewardId
        });
        if (props.clickFreeCardUseBtnTriggerFlowType === ClickFreeCardUseBtnTriggerFlowType.JUMP_TO_ANCHOR && props.anchorKey?.trim()) {
            ctx._uiInteractionAPI?.anchor.scrollToAnchor({
                anchorKey: props.anchorKey.trim(),
                animated: true
            });
        }
        else if (props.clickFreeCardUseBtnTriggerFlowType === ClickFreeCardUseBtnTriggerFlowType.OPEN_BOTTOM_MODAL) {
            ctx?._communication?.emit?.('cityChanged', {
                value: rawQueryInfoResponse?.moduleInfoList?.[0]?.cardModuleInfoVO?.selectedCardGroups?.[0] || 0,
                title: rawQueryInfoResponse?.moduleInfoList?.[0]?.cardModuleInfoVO?.cardGroupInfos?.[0]?.groupName || '全国'
            });
            ctx._communication?.emit('texBottomSlideModalStatusChange', {
                status: true,
                show: true,
                title: '货架'
            });
        }
    }}/>
      <CityFilterModal visible={popupMap[PopupKey.CITY_SELECT_MODAL]} cardGroupInfos={rawQueryInfoResponse?.moduleInfoList?.[0]?.cardModuleInfoVO?.cardGroupInfos ?? []} changeLimit={3} onClose={handleCloseCityModal} onOpened={() => {
        lxReport(BID_MAP.CITY_SELECTOR_MODAL_MV, BID_TYPE.MV);
    }} onSelectCity={(city) => {
        handleSelectCity(city);
        lxReport(BID_MAP.CITY_SELECT_MC, BID_TYPE.MC, {
            city_id: city.id,
            city_name: city.name
        });
    }} onCityCardShow={(city) => {
        lxReport(BID_MAP.CITY_SELECTOR_MV, BID_TYPE.MV, {
            city_id: city.id,
            city_name: city.name
        });
    }} onClickChangeButton={() => {
        lxReport(BID_MAP.REFRESH_CITIES_MC, BID_TYPE.MC);
    }} onClickSearchButton={() => {
        lxReport(BID_MAP.CITY_SEARCH_MC, BID_TYPE.MC);
    }}/>
      <GuestAssistModal visible={popupMap[PopupKey.GUEST_ASSIST_POPUP]} activityStatus={activityStatus} onClose={handleCloseAssistModal} onOpened={() => {
        lxReport(BID_MAP.ASSIST_MODAL_MV, BID_TYPE.MV);
    }} onClickJoin={() => {
        lxReport(BID_MAP.ASSIST_MODAL_JOIN_ACTIVITY_BUTTON_MC, BID_TYPE.MC);
    }}/>
      <LandmarkDetailModal visible={popupMap[PopupKey.LANDMARK_DETAIL_MODAL]} landmarkVO={selectedLandmark} onClose={handleCloseLandmarkDetailModal} children={props.children} onOpened={() => {
        lxReport(BID_MAP.LANDMARK_DETAIL_MV, BID_TYPE.MV);
    }}/>
      <CouponModal visible={popupMap[PopupKey.GET_COUPON_POPUP]} onClose={handleCloseCouponModal} onOpened={() => {
        lxReport(BID_MAP.COUPON_MODAL_MV, BID_TYPE.MV);
    }} rewardItemList={rawQueryRewardsResponse?.rewardItems ?? []}/>
      <FreeCardModal visible={popupMap[PopupKey.GET_FREE_ORDER_POPUP]} cityExploreViewModel={viewModel} onClose={handleCloseFreeCardModal} onOpened={() => {
        lxReport(BID_MAP.FREE_CARD_MODAL_MV, BID_TYPE.MV, {
            id: freeOrder?.rewardId,
            amount: freeOrder?.amount
        });
    }} freeOrderCardVO={freeOrder} onClickUseButton={() => {
        lxReport(BID_MAP.FREE_CARD_USE_MC, BID_TYPE.MC, {
            id: freeOrder?.rewardId,
            amount: freeOrder?.amount
        });
        handleCloseFreeCardModal();
        if (props.clickFreeCardUseBtnTriggerFlowType === ClickFreeCardUseBtnTriggerFlowType.JUMP_TO_ANCHOR && props.anchorKey?.trim()) {
            ctx._uiInteractionAPI?.anchor.scrollToAnchor({
                anchorKey: props.anchorKey.trim(),
                animated: true
            });
        }
        else if (props.clickFreeCardUseBtnTriggerFlowType === ClickFreeCardUseBtnTriggerFlowType.OPEN_BOTTOM_MODAL) {
            ctx?._communication?.emit?.('cityChanged', {
                value: rawQueryInfoResponse?.moduleInfoList?.[0]?.cardModuleInfoVO?.selectedCardGroups?.[0] || 0,
                title: rawQueryInfoResponse?.moduleInfoList?.[0]?.cardModuleInfoVO?.cardGroupInfos?.[0]?.groupName || '全国'
            });
            ctx._communication?.emit('texBottomSlideModalStatusChange', {
                status: true,
                show: true,
                title: '货架'
            });
        }
    }}/>
      <RewardRecords visible={popupMap[PopupKey.REWARD_RECORDS]} feConfig={props} activityId={props.activityId} initialTab={selectedRewardTabType} onClose={handleCloseRewardRecords} rankTime={{
        startTime: viewModel?.startTime,
        endTime: viewModel?.endTime
    }}/>
    </Sensor>;
}
export default memo(CityExplore);
